import { render, staticRenderFns } from "./SingleRecipientSendgridActivities.vue?vue&type=template&id=20b3ae5c"
import script from "./SingleRecipientSendgridActivities.vue?vue&type=script&lang=js"
export * from "./SingleRecipientSendgridActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports